import { Component, OnInit } from "@angular/core";
import { Meta, Title } from "@angular/platform-browser";
import { ActivatedRoute, Router } from "@angular/router";
import { UserService } from "src/app/services/user.service";
import { environment } from "src/environments/environment";
import { CatelougeModalComponent } from "../common/catelouge-modal/catelouge-modal.component";
import { MatDialog } from "@angular/material/dialog";
import { UpgradePackageComponent } from "../common/upgrade-package/upgrade-package.component";
import { AnalyticsService } from "src/app/services/analytics.service";
import { LoginModalComponent } from "../common/login-modal/login-modal.component";

@Component({
  selector: "app-digital-card-view",
  templateUrl: "./digital-card-view.component.html",
  styleUrl: "./digital-card-view.component.scss",
  standalone: false,
})
export class DigitalCardViewComponent implements OnInit {
  whatsapp: string = "https://api.whatsapp.com/send/?";
  facebook: string = "https://facebook.com/share/share.php/?";
  twitter: string = "https://x.com/share/?";
  user: any = null;

  analytic_type = {
    call : 1,
    whatsapp : 2,
    location : 3,
    email : 4,
    social_media : 5,
    product_gallery : 6,
    company_photos : 7,
    view_catelouge : 8,
    profil : 9,
    web : 10,
    personal_call_sale : 1,
    personal_call_purchas : 1,
    personal_whatsapp_sale : 2,
    personal_whatsapp_purchase : 2,
  }

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private userService: UserService,
    private titleService: Title,
    private metaService: Meta,
    public dialog: MatDialog,
    private analyticsService: AnalyticsService,
  ) {}

  ngOnInit(): void {
    const {user_id} = this.route.snapshot.params
    this.userService.getUserDetails({ id: user_id }).subscribe((res) => {
      if (res.success) {
        this.user = res.data;
        this.setMetaData();
        this.updateShareUrls();
      }
    });
  }

  updateShareUrls () {
		const url = environment.BASE_URL + '/digital-card/' + this.user.id + '/' + this.user.company.slug
		this.whatsapp = this.whatsapp+`text=${url}&preview=true`;
		this.facebook = this.facebook+`u=${url}`;
		this.twitter = this.twitter+`url=${url}`;
	}

  setMetaData() {
    const title =
      this.user.name +
      " || " +
      this.user.company.name +
      " || Our Digital Visiting Card";
    this.titleService.setTitle(title);
   this.userService.addMetaTag('name',"title",'content',title );
   this.userService.addMetaTag('name',"description",'content',this.stripHtmlTags(this.user.company?.about) );
    
   this.userService.addMetaTag('property',"og:title",'content',title );
   this.userService.addMetaTag('property',"og:description", 'content',this.stripHtmlTags(this.user.company?.about) );
   this.userService.addMetaTag('property',"og:url", 'content',`${environment.BASE_URL}/digital-card/${this.user.id}/${this.user.company?.slug}` );
   this.userService.addMetaTag('property',"og:image", 'content',this.user.company?.logo );
   this.userService.addMetaTag('property','og:image:width','content','500')
   this.userService.addMetaTag('property','og:image:height','content','500')
   this.userService.addMetaTag('property',"og:type", 'content',"profile" );
    
   this.userService.addMetaTag('name',"twitter:card", 'content',"summary_large_image" );
   this.userService.addMetaTag('name',"twitter:title", 'content',this.user.name );
   this.userService.addMetaTag('name',"twitter:description", 'content',this.stripHtmlTags(this.user.company?.about) );
   this.userService.addMetaTag('name',"twitter:image", 'content',this.user.company?.logo );
    
  
  }

  stripHtmlTags(input: any): string {
    return input.replace(/<[^>]*>/g, '');
  }

  setTitle(newTitle: string) {
    this.titleService.setTitle(newTitle);
  }

  open_link = (link) => {
    window.open(link,'_blank')
  }

  onActionBtnClick(action_type=null,company=null,value=null){

    const actions = {
      email : ()=>{
        this.open_link(`${value}`)
      },
      web : ()=>{
        this.open_link(`${value}`)
      },
      personal_whatsapp_sale : ()=>{
        this.open_link(`${value}`)
      },
      personal_call_sale : ()=>{
        // this.open_link(`${value}`)
        window.alert(value)
      },
      personal_whatsapp_purchase : ()=>{
        this.open_link(`${value}`)
      },
      personal_call_purchas : ()=>{
        // this.open_link(`${value}`)
        window.alert(value)
      },
      product_gellery : () => {
        this.router.navigate(['company',company.slug,'gallery'],{state:{photos : company?.product_photos}})
      },
      company_photo : () => {
        this.router.navigate(['company',company.slug,'photos'],{state:{photos : company?.company_photos}})
      },
      about_company : () => {
        this.router.navigate(['company',company.slug,'about'],{state:{about  : company?.about}})
      },
      view_catelouge : () => {
        this.dialog.open(CatelougeModalComponent,{
          'data' : {
            'catalogs':company.catalogs
          }
        })
      },
    }


    if(action_type==='about_company'){
      this.analytics(this.analytic_type[action_type],company.id)
      actions[action_type]()
      return ;
    }

    if(!this.userService.isLoggedIn()){
      this.dialog.open(LoginModalComponent)
      return ;
    }

    const access_roles = {
			1 : 'tile_manufacture',
			2 : 'sanitary_manufacture',
			3 : 'various_manufacture',
			4 : 'trader',
			5 :  company.country_id !== 1 ? 'dealer_india' : 'dealer_other',
			6 : 'transporter',
			7 : 'supplier',
			8 : 'hotel',
			9 : 'service_provider',
			10 : 'cab',
		}

    const access = this.userService.getAccessRoleByType(access_roles[company.type])
    const is_allowed = access[action_type] ?? false 

    if (!is_allowed) {
      this.dialog.open(UpgradePackageComponent)
      return ;
    }

    if(actions[action_type]){
      this.analytics(this.analytic_type[action_type],company.id)
      actions[action_type]()
      return ;
    }
    
  }

  analytics(type,company_id): void {
    this.analyticsService.saveCount({ id: company_id, type: type }).subscribe();
  }

}
